import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { AutoresponderComponent } from 'src/app/components/autoresponder/autoresponder.component';
import { ChannelSelectorModule } from 'src/app/components/channel-selector/channel-selector.module';
import { CustomFieldsModule } from 'src/app/components/custom-fields/custom-fields.module';
import { ExternalCrmAccountSelectorComponent } from 'src/app/components/external-crm-account-selector/external-crm-account-selector.component';
import { IntakeSettingsComponent } from 'src/app/components/intake-settings/intake-settings.component';
import { SlackTextEditorComponent } from 'src/app/components/slack-text-editor/slack-text-editor.component';
import { SupportStepsModule } from 'src/app/components/support-steps/support-steps.module';

import { ColonToEmojiPipe } from '../../../../pipes/colonToEmoji.pipe';

import { CustomerAdminSettingsPageRoutingModule } from './customer-admin-settings-routing.module';
import { CustomerAdminSettingsPage } from './customer-admin-settings.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxTippyModule,
    CustomerAdminSettingsPageRoutingModule,
    CustomFieldsModule,
    SupportStepsModule,
    ChannelSelectorModule,
    ExternalCrmAccountSelectorComponent,
    AutoresponderComponent,
    SlackTextEditorComponent,
    IntakeSettingsComponent,
    ColonToEmojiPipe,
  ],
  declarations: [CustomerAdminSettingsPage],
})
export class CustomerAdminSettingsPageModule {}
